import { render, staticRenderFns } from "./DailyScoreDetail.vue?vue&type=template&id=a54920a8&"
import script from "./DailyScoreDetail.vue?vue&type=script&lang=js&"
export * from "./DailyScoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports